
import { IPortfolioDistributionItem, IPortfolioDistributionItemLevel2 } from "../../../services/ManagedPortfolioService";
import { TTartaExterior, TTartaInterior } from "../../../services/OmniaService";



type TFormatToPieChartProps = {
    activo1: TTartaExterior[];
    activo1y2: TTartaInterior[];
};

export const FormatToPieChart = ( { activo1, activo1y2 } : TFormatToPieChartProps) => {

    const dataCircle: IPortfolioDistributionItem[] = []

    for (let i: number = 0; i < activo1.length; i++) {
        const dataLevel2: IPortfolioDistributionItemLevel2[] = []
        for (let j: number = 0; j < activo1y2.length; j++) {
            if (activo1y2[j].tipoactivo1 === activo1[i].tipoactivo1) {
                dataLevel2.push({
                    name: activo1y2[j].tipoactivo2,
                    value: activo1y2[j].valor
                })
            }
        }
        dataCircle.push(
            {
                name: activo1[i].tipoactivo1,
                value: activo1[i].valor,
                level2: dataLevel2.length > 0 ? dataLevel2 : undefined
            }
        ) 
    };
    
    return dataCircle;
};